import { createRoot, Root } from 'react-dom/client';
import videojs from 'video.js';

import { VideoImageSource } from '@xing-com/crate-common-graphql-types';

import { Thumbnail } from './thumbnail';

const vjsComponent = videojs.getComponent('Component');

export const setupThumbnail = async (
  xingPlayer: XingPlayer,
  sprites: VideoImageSource[]
): Promise<void> => {
  const vttSrc = sprites[1].source;

  const mouseTimeDisplay =
    xingPlayer.videojs.controlBar.progressControl.seekBar.mouseTimeDisplay;

  const timeToolipEl = mouseTimeDisplay?.timeTooltip?.el_ as
    | HTMLElement
    | undefined;

  if (timeToolipEl) {
    const vttResponse = await fetch(vttSrc, { method: 'GET' });
    const vtt = await vttResponse.text();

    mouseTimeDisplay.addChild(
      new ThumbnailContainer(xingPlayer, timeToolipEl, vtt, vttSrc),
      {},
      1
    );
  }
};

class ThumbnailContainer extends vjsComponent {
  private vtt: string;
  private vttSrc: string;
  private timeToolipEl: HTMLElement;
  private rootElement: Root;

  constructor(
    xingPlayer: XingPlayer,
    timeToolipEl: HTMLElement,
    vtt: string,
    vttSrc: string
  ) {
    super(xingPlayer.videojs);

    this.vtt = vtt;
    this.vttSrc = vttSrc;
    this.timeToolipEl = timeToolipEl;

    this.rootElement = createRoot(this.el());

    /* Bind the current class context to the mount method */
    this.mount = this.mount.bind(this);

    /* When player is ready, call method to mount React component */
    xingPlayer.videojs.ready(() => this.mount());

    /* Remove React root when component is destroyed */
    // this.on('dispose', () => this.rootElement.unmount());
  }

  mount(): void {
    this.rootElement.render(
      <>
        <Thumbnail
          timeToolipEl={this.timeToolipEl}
          vtt={this.vtt}
          vttSrc={this.vttSrc}
        />
      </>
    );
  }
}
